import * as React from 'react';
import { Button, InputText } from '@innovyze/stylovyze/lib/components';
import LoadingPage from '@innovyze/stylovyze/lib/components/LoadingPage';
import { useAccessToken } from '@innovyze/stylovyze/lib/hooks/authStates';
import { selectAuthenticationContext } from '@innovyze/stylovyze/lib/selectors/authenticationContext.selectors';
import { selectLoginContext } from '@innovyze/stylovyze/lib/selectors/login.selectors';
import { AUTHENTICATION_URL_PARAMS } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
import { LOGIN_STATUS_ENUM } from '@innovyze/stylovyze/lib/types/login.types';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Info360LogoIllustration } from '../../illustrations';
import { ButtonsWithLabelWrapper, ButtonsWrapper, Label, StyledAnchor, StyledForm, StyledLink, } from './LoginDomainPrompt.styles';
import useGetLoginAttrs from './useGetLoginAttrs';
/**
 * Add a description for your component here
 */
export const LoginDomainPrompt = () => {
    const loginState = useGetLoginAttrs();
    const { status } = useSelector(selectLoginContext);
    const { token: tokenReduxState } = useSelector(selectAuthenticationContext);
    const { errors, touched } = useFormikContext();
    const accessTokenCookie = useAccessToken();
    const hasAuth0Token = !!tokenReduxState || !!accessTokenCookie;
    if (hasAuth0Token) {
        return React.createElement(Redirect, { to: AUTHENTICATION_URL_PARAMS.AUTH0 });
    }
    return (React.createElement(StyledForm, null,
        React.createElement(Info360LogoIllustration, { color: "#000" }),
        React.createElement(InputText, { fieldAttrs: { name: 'domain' }, textField: {
                label: 'Company Domain Name',
                fullWidth: true,
                disabled: status !== LOGIN_STATUS_ENUM.IDLE,
                error: touched.domain && !!errors.domain,
                helperText: touched.domain && errors.domain,
            } }),
        loginState.additionalLinks?.map((aLink, index) => aLink.to ? (React.createElement(StyledLink, { key: index, to: aLink.to || '', onClick: aLink.onClick }, aLink.text)) : (React.createElement(StyledAnchor, { key: index, href: aLink.to || '', onClick: aLink.onClick }, aLink.text))),
        React.createElement(ButtonsWithLabelWrapper, null,
            loginState.buttonsLabel && (React.createElement(Label, null, loginState.buttonsLabel)),
            React.createElement(ButtonsWrapper, { buttons: loginState.buttons.length }, loginState.buttons.map((button, index) => (React.createElement(Button, { key: index, ...button }))))),
        status === LOGIN_STATUS_ENUM.PENDING && React.createElement(LoadingPage, { size: "md" })));
};
LoginDomainPrompt.defaultProps = {};
export default LoginDomainPrompt;
